let f = true;
let l = false;
const q = [];

const init = () => {
  l = true;
  q.forEach(x => x());
};

const caricaComponente = ({ callback, ...params }) => {
  if (f) {
    f = false;
    !!callback && q.push(callback);
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.src = `${params.url}/home/browserexportjs`;
    e.async = false;
    e.defer = false;
    e.onload = () => window.inizializzaPotenzialiPratiche({ ...params, callback: init });
    const h = document.getElementsByTagName('head')[0];
    h.insertBefore(e, h.lastChild);
  }
  else if (l) {
    !!callback && callback();
  }
  else {
    !!callback && q.push(callback);
  }
};

module.exports = {
  inizializza(params) {
    caricaComponente(params);
  },

};
